var FullScreenHelper = /** @class */ (function () {
    function FullScreenHelper() {
    }
    FullScreenHelper.exitFullScreen = function () {
        var de = document.documentElement;
        var doc = document;
        if (de.exitFullscreen) {
            de.exitFullscreen();
        }
        else if (de.mozCancelFullScreen) {
            de.mozCancelFullScreen();
        }
        else if (de.webkitCancelFullScreen) {
            de.webkitCancelFullScreen();
        }
        else if (doc.fullscreenElement ||
            doc.webkitFullscreenElement ||
            doc.mozFullScreenElement) {
            document.exitFullscreen();
        }
    };
    return FullScreenHelper;
}());
export { FullScreenHelper };
